import { EElevatorType, JsonQuery } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';

const TEXT_MAP: { [key in EElevatorType]: string } = {
  [EElevatorType.Any]: 'Есть лифт',
  [EElevatorType.Service]: 'Есть грузовой лифт',
};

export const elevators: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = new JsonQuery(jsonQuery).getElevatorType();
    if (value == null) {
      return null;
    }

    return [
      {
        group: 'elevators',
        text: TEXT_MAP[value],
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setElevatorType',
      arguments: [null],
    });
  },
};
